import { render } from "./Contact.vue?vue&type=template&id=5e017433"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Pages/Contact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e017433"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e017433', __exports__)) {
    api.reload('5e017433', __exports__)
  }
  
  module.hot.accept("./Contact.vue?vue&type=template&id=5e017433", () => {
    api.rerender('5e017433', render)
  })

}


export default __exports__